// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"_3o2yHd","icon":"_1_k9vZ","content":"_1t4MS3","shine-lines":"_1SPix4"};